export const rsaEncryption = async (
  cardNumber: string,
  publicKeyPem: string,
) => {
  const encodedText = new TextEncoder().encode(cardNumber);
  const binaryDer = window.atob(
    publicKeyPem.replace(/(-----(BEGIN|END) PUBLIC KEY-----|\n)/g, ''),
  );
  const binaryKey = Uint8Array.from(binaryDer, (val) => val.charCodeAt(0));

  try {
    const cryptoKey: CryptoKey = await window.crypto.subtle.importKey(
      'spki',
      binaryKey.buffer,
      { name: 'RSA-OAEP', hash: 'SHA-512' },
      true,
      ['encrypt'],
    );
    const encryptedData: ArrayBuffer = await window.crypto.subtle.encrypt(
      { name: 'RSA-OAEP' },
      cryptoKey,
      encodedText,
    );
    const encryptedBase64 = btoa(
      String.fromCharCode(...new Uint8Array(encryptedData)),
    );
    return encryptedBase64;
  } catch {
    return '';
  }
};
